// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"AvatarColorPicker_checkbox__1jxI2"};